import * as React from 'react';
import { PageBody } from '../../../../components/page-components/PageBody';
import { PageContent } from '../../../../components/page-components/PageContent';
import { PageNames } from '../../../../utils/app-constants';
import { OrdersEnteredTile } from '../components/OrdersEnteredTile';
import { SinglewideProductionTile } from '../components/SinglewideProductionTile';
import { WaitingOnSomeoneTile } from '../components/WaitingOnSomeoneTile';
import '../Dashboard.scss';

/**
 * The home page: a tile for each thing the people who run the business want to see at a glance
 */
export const DashboardScene = () => (
    <PageContent pageName={ PageNames.DASHBOARD }>
        <PageBody>
            <div className="dashboard-tiles">
                <SinglewideProductionTile />
                <div className="dashboard-tile-row">
                    <OrdersEnteredTile />
                    <WaitingOnSomeoneTile />
                </div>
            </div>
        </PageBody>
    </PageContent>
);
